import React, { useMemo } from 'react';
import { moneyFormat } from 'helpers/NumberFormat';
import { Button, List, makeStyles } from '@material-ui/core';
import OrderViewTotalListText from './OrdersViewTotalListText';
import DialogInput, { DialogInputConsumer } from 'components/dialogs/DialogInput';

const styles = makeStyles({
  actions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 15,
    marginTop: 15,
  },
  container: {
    height: 330,
  },
});

interface OrderViewTotalListProps {
  order: any;
  onExited: any;
  finalTotal: any;
  commission: any;
}

const OrderViewTotalList: React.FC<OrderViewTotalListProps> = ({ order, onExited, finalTotal, commission }) => {
  const classes = styles();

  const commissionAdd = useMemo(() => moneyFormat(commission), [commission]);

  const final = useMemo(() => moneyFormat(finalTotal), [finalTotal]);

  return (
    <DialogInput maxWidth="sm" onExited={onExited}>
      <DialogInputConsumer>
        {context => (
          <div className={classes.container}>
            <List>
              <OrderViewTotalListText title="Produtos" text={order.length} />
              <OrderViewTotalListText title="Comissão" text={`${commissionAdd}`} />
              <OrderViewTotalListText title="Total" text={final} />
            </List>
            <div className={classes.actions}>
              <Button onClick={context.handleClose} size="small" variant="contained" color="primary">
                Fechar
              </Button>
            </div>
          </div>
        )}
      </DialogInputConsumer>
    </DialogInput>
  );
};

export default OrderViewTotalList;
